// This file was automatically generated from Excel data
// src/components/BattlegearDatabase.js

// Helper function for creating unique card keys
function createUniqueCardKey(card) {
  // Combine name and set for a unique identifier
  // For backward compatibility, return the ID if it's already globally unique
  if (card.id && card.id.includes('-')) {
    return card.id;
  }
  
  // If already has a uniqueId, use it
  if (card.uniqueId) {
    return card.uniqueId;
  }
  
  // Otherwise create a composite key using name and set
  return `${card.name}__${card.set || 'unknown'}`;
}

// Pre-populated battlegear database
export const battlegearDatabase = [
  {
    "id": "136/232",
    "name": "Aqua Shield",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 5 Energy.\r\nSacrifice Aqua Shield: Heal 15 damage to target Creature.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, David Curiel",
    "imageUrl": "https://i.imgur.com/O0dWhvv.png",
    "uniqueId": "Aqua Shield__dop"
  },
  {
    "id": "137/232",
    "name": "Cyclance",
    "set": "dop",
    "rarity": "rare",
    "ability": "Sacrifice Cyclance: equipped Creature gains :air:Air until the end of combat.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/WFBPijk.png",
    "uniqueId": "Cyclance__dop"
  },
  {
    "id": "138/232",
    "name": "Diamond of Vlaric",
    "set": "dop",
    "rarity": "rare",
    "ability": "Sacrifice Diamond of Vlaric: equipped Creature gains :earth:Earth until the end of combat.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Edwin Nebres, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/sgaso4S.png",
    "uniqueId": "Diamond of Vlaric__dop"
  },
  {
    "id": "139/232",
    "name": "Dragon Pulse",
    "set": "dop",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 25 :courage:Courage.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, David Curiel",
    "imageUrl": "https://i.imgur.com/Jl1hk3J.png",
    "uniqueId": "Dragon Pulse__dop"
  },
  {
    "id": "140/232",
    "name": "Elixir of Tenacity",
    "set": "dop",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 10 :courage:Courage and an additional 10 :speed:Speed.\r\n\r\nIf equipped Creature has at least 50 :power:Power, it has an additional 10 Energy.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Aris Illopoulos, Edwin Nebres, David Curiel",
    "imageUrl": "https://i.imgur.com/RTyULyY.png",
    "uniqueId": "Elixir of Tenacity__dop"
  },
  {
    "id": "141/232",
    "name": "Flux Bauble",
    "set": "dop",
    "rarity": "rare",
    "ability": "At the beginning of combat, look at the top two cards of your Location Deck. Put one of them on top of that deck and the other on the bottom.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/aKVIkOT.png",
    "uniqueId": "Flux Bauble__dop"
  },
  {
    "id": "142/232",
    "name": "Gauntlets of Might",
    "set": "dop",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 25 :power:Power.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Aris Illopoulos, Edwin Nebres, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/MZE9NlY.png",
    "uniqueId": "Gauntlets of Might__dop"
  },
  {
    "id": "143/232",
    "name": "Liquilizer",
    "set": "dop",
    "rarity": "rare",
    "ability": "Sacrifice Liquilizer: equipped Creature gains :water:Water until the end of combat.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/MDzBVYr.png",
    "uniqueId": "Liquilizer__dop"
  },
  {
    "id": "144/232",
    "name": "Mipedian Cactus",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 15 :wisdom:Wisdom.\r\nEquipped Mipedian Creature has :mipedianmugic:: equipped Creature can move to any space on the board as if it were adjacent.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Keith Conroy, Anthony Washington",
    "imageUrl": "https://i.imgur.com/L8JtwA4.png",
    "uniqueId": "Mipedian Cactus__dop"
  },
  {
    "id": "145/232",
    "name": "Mowercycle",
    "set": "dop",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 25 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Anthony Washington, Edwin Nebres, Francis Barrios",
    "imageUrl": "https://i.imgur.com/1KaJWyv.png",
    "uniqueId": "Mowercycle__dop"
  },
  {
    "id": "146/232",
    "name": "Mugician's Lyre",
    "set": "dop",
    "rarity": "common",
    "ability": "Sacrifice Mugician's Lyre: Put a Mugic counter on the equipped Creature",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent, Edwin Nebres",
    "imageUrl": "https://i.imgur.com/MFng08Z.png",
    "uniqueId": "Mugician's Lyre__dop"
  },
  {
    "id": "147/232",
    "name": "Nexus Fuse",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 5 Energy.\r\nSacrifice Nexus Fuse: Deal 15 damage to target Creature.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Edwin Nebres, Etienne St.Laurent, Andrew Bradshaw",
    "imageUrl": "https://i.imgur.com/97LjbD8.png",
    "uniqueId": "Nexus Fuse__dop"
  },
  {
    "id": "148/232",
    "name": "Orb of Foresight",
    "set": "dop",
    "rarity": "rare",
    "ability": "At the beginning of combat, look at the top three cards of your Attack Deck. Put one of them on top of that deck and the other two on the bottom in any order.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Edwin Nebres, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/dYMVHMP.png",
    "uniqueId": "Orb of Foresight__dop"
  },
  {
    "id": "149/232",
    "name": "Phobia Mask",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "Equipped Creature has \"Intimidate: :courage:Courage 10\" and \"Intimidate: :power:Power 10.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, David Curiel, Edwin Nebres",
    "imageUrl": "https://i.imgur.com/s9BxCXc.png",
    "uniqueId": "Phobia Mask__dop"
  },
  {
    "id": "150/232",
    "name": "Prism of Vacuity",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "Equipped Creature has an additional 5 Energy.\r\nSacrifice Prism of Vacuity: Target Creature loses 20 :power:Power.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/eNFUPdt.png",
    "uniqueId": "Prism of Vacuity__dop"
  },
  {
    "id": "151/232",
    "name": "Pyroblaster",
    "set": "dop",
    "rarity": "rare",
    "ability": "Sacrifice Pyroblaster: equipped Creature gains :fire:Fire until the end of combat.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/7WIzgvm.png",
    "uniqueId": "Pyroblaster__dop"
  },
  {
    "id": "152/232",
    "name": "Ring of Na'arin",
    "set": "dop",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 10 :power:Power and an additional 10 :wisdom:Wisdom.\r\nIf equipped Creature has at least 50 :courage:Courage, it has an additional 10 Energy.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/zlmNMdC.png",
    "uniqueId": "Ring of Na'arin__dop"
  },
  {
    "id": "153/232",
    "name": "Riverland Star",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 15 :courage:Courage.\r\nEquipped OverWorld Creature has \"When equipped Creature deals :water:Water damage, heal 5 damage to it.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, David Curiel, Edwin Nebres",
    "imageUrl": "https://i.imgur.com/Qwfs3c7.png",
    "uniqueId": "Riverland Star__dop"
  },
  {
    "id": "154/232",
    "name": "Skeletal Steed",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "Equipped Creature has \"Range\" and \"Swift 1.\"\r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Kozutoku matsumoto",
    "imageUrl": "https://i.imgur.com/8vwGnVy.png",
    "uniqueId": "Skeletal Steed__dop"
  },
  {
    "id": "155/232",
    "name": "Spectral Viewer",
    "set": "dop",
    "rarity": "rare",
    "ability": "When equipped Creature becomes engaged, Creatures engaged with it lose and cannot gain Invisibility.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent, Edwin Nebres",
    "imageUrl": "https://i.imgur.com/0hn5oni.png",
    "uniqueId": "Spectral Viewer__dop"
  },
  {
    "id": "156/232",
    "name": "Staff of Wisdom",
    "set": "dop",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 25 :wisdom:Wisdom.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Edwin Nebres, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/onFeCjn.png",
    "uniqueId": "Staff of Wisdom__dop"
  },
  {
    "id": "157/232",
    "name": "Stone Mail",
    "set": "dop",
    "rarity": "ultra rare",
    "ability": "Equipped Creature cannot move.\r\nEquipped Creature has an additional 50 Energy.\r\nAll damage dealt to equipped Creature is increased by 5.\r\nEquipped Creature has no abilities and cannot gain abilities.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Jimmy Tran",
    "imageUrl": "https://i.imgur.com/rcpF5dr.png",
    "uniqueId": "Stone Mail__dop"
  },
  {
    "id": "158/232",
    "name": "Talisman of the Mandiblor",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 15 :speed:Speed.\r\nEquipped Danian Creature has \"Sacrifice equipped Creature: Return a Mandiblor Creature Card in your general discard pile to play to any unoccupied space on the Battleboard.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Rudy Nebres, Anthony Washington",
    "imageUrl": "https://i.imgur.com/ciQOuJV.png",
    "uniqueId": "Talisman of the Mandiblor__dop"
  },
  {
    "id": "159/232",
    "name": "Torrent Krinth",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "Equipped Creature has \":water:Water 5.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Aris Illopoulos, Anthony Washington",
    "imageUrl": "https://i.imgur.com/1lPjYZJ.png",
    "uniqueId": "Torrent Krinth__dop"
  },
  {
    "id": "160/232",
    "name": "Torwegg",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "Equipped Creature has \":air:Air 5.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Edwin Nebres, Andrew Bradshaw, David Curiel",
    "imageUrl": "https://i.imgur.com/Wgvf1wh.png",
    "uniqueId": "Torwegg__dop"
  },
  {
    "id": "161/232",
    "name": "Viledriver",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "Equipped Creature has \":fire:Fire 5.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/TaiMNEV.png",
    "uniqueId": "Viledriver__dop"
  },
  {
    "id": "162/232",
    "name": "Vlaric Shard",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "Equipped Creature has \":earth:Earth 5.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Adrian Barrios, David Curiel",
    "imageUrl": "https://i.imgur.com/D0Sqckh.png",
    "uniqueId": "Vlaric Shard__dop"
  },
  {
    "id": "163/232",
    "name": "Whepcrack",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 15 :power:Power.\r\nEquipped UnderWorld Creature has \":fire:Fire 5.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent, Edwin Nebres",
    "imageUrl": "https://i.imgur.com/k3NCFU7.png",
    "uniqueId": "Whepcrack__dop"
  },
  {
    "id": "164/232",
    "name": "Windstrider",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Equipped Creature has \"Swift 2.\"\r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, David Curiel, Edwin Nebres",
    "imageUrl": "https://i.imgur.com/Qq4HTuG.png",
    "uniqueId": "Windstrider__dop"
  },
  {
    "id": "56/100",
    "name": "Danian Carapace",
    "set": "zoth",
    "rarity": "super rare",
    "ability": "When equipped Creature deals damage to an Uninfected Creature, Infect that Creature.\r\nWhen the equipped Creature is destroyed while engaged, destroy all Battlegear equipped to the opposing engaged Creature. Then, if that Creature is Unequipped, equip Danian carapace to it.\r\n(Players control any Battlegear equipped to Creatures they control.)",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Adrian Barrios, Anthony Washington",
    "imageUrl": "https://i.imgur.com/awD7eXN.png",
    "uniqueId": "Danian Carapace__zoth"
  },
  {
    "id": "57/100",
    "name": "Elementalist Pauldrons",
    "set": "zoth",
    "rarity": "rare",
    "ability": "Equipped Creature has an additional 5 Energy and 15 :power:Power. \r\nEquipped Elementalist Creature has all Elemental Types your Creatures have.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/nRUV8OX.png",
    "uniqueId": "Elementalist Pauldrons__zoth"
  },
  {
    "id": "58/100",
    "name": "Ice Cloak",
    "set": "zoth",
    "rarity": "rare",
    "ability": "When Ice Cloak is flipped face-up, if equipped Creature is engaged with a Creature with :fire:Fire, equipped Creature gains 10 Energy.\r\nEquipped Creature has \":fire:Fire proof 10.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/4qYLdzL.png",
    "uniqueId": "Ice Cloak__zoth"
  },
  {
    "id": "59/100",
    "name": "Mandiblor Crown",
    "set": "zoth",
    "rarity": "common",
    "ability": "Equipped Creature has Creature Type \"Mandiblor\" in addition to its other types.\r\nEquipped Creature has \"Hive: equipped Creature has an additional 5 Energy.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/GIuqyyp.png",
    "uniqueId": "Mandiblor Crown__zoth"
  },
  {
    "id": "60/100",
    "name": "Scout's Monocular",
    "set": "zoth",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 5 Energy and 15 :wisdom:Wisdom.\r\nEquipped Scout Creature has :genericmugic:: Turn target face-down Battlegear face-up.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/O3V6LTV.png",
    "uniqueId": "Scout's Monocular__zoth"
  },
  {
    "id": "61/100",
    "name": "Stingblade Prototype",
    "set": "zoth",
    "rarity": "super rare",
    "ability": "When Hive is activated, the next time an Attack would deal damage this turn, it deals 10 damage instead.",
    "flavorText": "",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/chUhMt2.png",
    "uniqueId": "Stingblade Prototype__zoth"
  },
  {
    "id": "62/100",
    "name": "Supercharged Alterant",
    "set": "zoth",
    "rarity": "uncommon",
    "ability": "When Supercharged Alterant is flipped face-up, choose a Discipline. Equipped Creature gains 100 in the chosen Discipline.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Khary Randolph, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/UsgTdkw.png",
    "uniqueId": "Supercharged Alterant__zoth"
  },
  {
    "id": "63/100",
    "name": "Sword of Khy'at",
    "set": "zoth",
    "rarity": "uncommon",
    "ability": "Equipped Creature has an additional 5 Energy and 15 :speed:Speed. \r\nEquipped Warrior Creature has \"When equipped Creature deals 20 or more attack damage, deal 5 damage to target Creature.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Patrick Gagne, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/WzgSGFa.png",
    "uniqueId": "Sword of Khy'at__zoth"
  },
  {
    "id": "64/100",
    "name": "Telebracers",
    "set": "zoth",
    "rarity": "super rare",
    "ability": "When Telebracers is flipped face-up, reveal a new active Location.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/ARdx2DC.png",
    "uniqueId": "Telebracers__zoth"
  },
  {
    "id": "65/100",
    "name": "Ur-Shard",
    "set": "zoth",
    "rarity": "ultra rare",
    "ability": "Equipped Creature has \":earth:Earth 5\" and \"Recklessness 5.\"\r\nIf equipped Creature is destroyed while engaged, destroy all Battlegear equipped to the opposing engaged Creature. Then, if that Creature is Unequipped, equip Ur-Shard to it.\r\n(Players control any Battlegear equipped to Creatures they control.)",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Khary Randolph, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/dx70GJj.png",
    "uniqueId": "Ur-Shard__zoth"
  },
  {
    "id": "66/100",
    "name": "Challor",
    "set": "ss",
    "rarity": "super rare",
    "ability": "Equipped Creature cannot be targeted by abilities.\r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/8rp1tPo.png",
    "uniqueId": "Challor__ss"
  },
  {
    "id": "68/100",
    "name": "Entropy Modulator",
    "set": "ss",
    "rarity": "common",
    "ability": "Sacrifice Entropy Modulator: Target attack deals 15 damage.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/MSFDBeJ.png",
    "uniqueId": "Entropy Modulator__ss"
  },
  {
    "id": "69/100",
    "name": "Heptadd's Crown",
    "set": "ss",
    "rarity": "rare",
    "ability": "Equipped Creature can play Mugic of any tribe. \r\nWhen a Mugic or ability is played by equipped Creature, deal 10 damage to it.\r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/rpOh1gg.png",
    "uniqueId": "Heptadd's Crown__ss"
  },
  {
    "id": "70/100",
    "name": "Hunter's Lure",
    "set": "ss",
    "rarity": "uncommon",
    "ability": "Sacrifice Hunter's Lure: Relocate both engaged Creatures to any unoccupied space on the Battleboard.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/T4GrsUb.png",
    "uniqueId": "Hunter's Lure__ss"
  },
  {
    "id": "71/100",
    "name": "Lightning Canister",
    "set": "ss",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 5 Energy. \r\nWhen Lightning Canister is put into your general discard pile from face-up, deal 5 damage to target engaged Creature.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/8Pi76oa.png",
    "uniqueId": "Lightning Canister__ss"
  },
  {
    "id": "72/100",
    "name": "Ravita Flower",
    "set": "ss",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 5 Energy. \r\nSacrifice Ravita Flower: Put 2 Mugic counters on target Conjuror Creature.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/l8DiCKA.png",
    "uniqueId": "Ravita Flower__ss"
  },
  {
    "id": "73/100",
    "name": "Reality Field Generator",
    "set": "ss",
    "rarity": "rare",
    "ability": "When equipped Creature enters a space with a Mirage Location, shuffle that Mirage Location into its controller's Location Deck. \r\nMirage Locations cannot be placed in equipped Creature's space.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/ooAIbdG.png",
    "uniqueId": "Reality Field Generator__ss"
  },
  {
    "id": "67/100",
    "name": "The Doomhammer",
    "set": "ss",
    "rarity": "ultra rare",
    "ability": "Equipped Creature deals an additional 5 Attack damage to UnderWorld and Danian Creatures.\r\nEquipped Danian Creature has \":earth:Earth 5.\"\r\nEquipped UnderWorld Creature has an additional 50 :power:Power.",
    "flavorText": "",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/nj3cDhO.png",
    "uniqueId": "The Doomhammer__ss"
  },
  {
    "id": "74/100",
    "name": "Warbeast Power Leash",
    "set": "ss",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 5 Energy. \r\nEquipped Warbeast Creature has \"Recklessness 5,\" has an additional 5 Energy for each Conjuror Creature you control and deals an additional 5 damage with attacks.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/sewW8cU.png",
    "uniqueId": "Warbeast Power Leash__ss"
  },
  {
    "id": "75/100",
    "name": "Wind Whip",
    "set": "ss",
    "rarity": "uncommon",
    "ability": "Equipped Mipedian Creature has :air:Air.\r\nIf equipped Creature is a Conjuror Creature, Warbeast Creatures you control have \"Recklessness 5.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/Uie1SgI.png",
    "uniqueId": "Wind Whip__ss"
  },
  {
    "id": "126/222",
    "name": "Aerodrone",
    "set": "btd",
    "rarity": "super rare",
    "ability": "When equipped Creature deals :air:Air damage, you can look at the top four cards of your Attack Deck and put them back on top in any order.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/yYQUlTw.png",
    "uniqueId": "Aerodrone__btd"
  },
  {
    "id": "127/222",
    "name": "Algal Wings of Attraction",
    "set": "btd",
    "rarity": "ultra rare",
    "ability": "Adjacent Creatures to equipped Creature must move into its space if able.",
    "flavorText": "",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/QujDths.png",
    "uniqueId": "Algal Wings of Attraction__btd"
  },
  {
    "id": "128/222",
    "name": "Alluring Bait",
    "set": "btd",
    "rarity": "rare",
    "ability": "Equipped Creature has \"Discard a Mugic Card: Relocate target opposing unengaged Creature to any unoccupied space adjacent to this Creature.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/Stfc6B1.png",
    "uniqueId": "Alluring Bait__btd"
  },
  {
    "id": "129/222",
    "name": "Aspect Amplifier: Agility",
    "set": "btd",
    "rarity": "common",
    "ability": "Equipped Creature has \"Outperform :speed:Speed 5.\" (Outperform increases the damage of attacks that success at least one Stat Check, Challenge, or Stat Fail of the indicated Discipline.)",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/CxYXfO5.png",
    "uniqueId": "Aspect Amplifier: Agility__btd"
  },
  {
    "id": "130/222",
    "name": "Aspect Amplifier: Bravery",
    "set": "btd",
    "rarity": "common",
    "ability": "Equipped Creature has \"Outperform :courage:Courage 5.\" (Outperform increases the damage of attacks that success at least one Stat Check, Challenge, or Stat Fail of the indicated Discipline.)",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/3yzudhs.png",
    "uniqueId": "Aspect Amplifier: Bravery__btd"
  },
  {
    "id": "131/222",
    "name": "Aspect Amplifier: Might",
    "set": "btd",
    "rarity": "common",
    "ability": "Equipped Creature has \"Outperform :power:Power 5.\" (Outperform increases the damage of attacks that success at least one Stat Check, Challenge, or Stat Fail of the indicated Discipline.)",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/54jlmZy.png",
    "uniqueId": "Aspect Amplifier: Might__btd"
  },
  {
    "id": "132/222",
    "name": "Aspect Amplifier: Wit",
    "set": "btd",
    "rarity": "common",
    "ability": "Equipped Creature has \"Outperform :wisdom:Wisdom 5.\" (Outperform increases the damage of attacks that success at least one Stat Check, Challenge, or Stat Fail of the indicated Discipline.)",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/PBPUTF0.png",
    "uniqueId": "Aspect Amplifier: Wit__btd"
  },
  {
    "id": "133/222",
    "name": "Brain Amplifier",
    "set": "btd",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 15 :wisdom:Wisdom and 5 Energy.\r\nWhen equipped Creature wins combat, put a Mugic counter on it.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/J73G94I.png",
    "uniqueId": "Brain Amplifier__btd"
  },
  {
    "id": "134/222",
    "name": "Breath of the Desert",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "Equipped Creature has an additional 10 :speed:Speed. \r\nSacrifice Breath of the Desert: equipped Creature gains \":air:Air 5.\" Play this ability only while equipped Creature is engaged.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/tPVU6AY.png",
    "uniqueId": "Breath of the Desert__btd"
  },
  {
    "id": "135/222",
    "name": "Destructozooka",
    "set": "btd",
    "rarity": "rare",
    "ability": "When Destructozooka is flipped face-up, choose an Elemental Type. Equipped Creature gains the chosen Elemental Type and \"Element 5\" of the chosen Elemental Type.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "David Curiel, Andrew Bradshaw",
    "imageUrl": "https://i.imgur.com/3TKQrcO.png",
    "uniqueId": "Destructozooka__btd"
  },
  {
    "id": "136/222",
    "name": "Hive Amber",
    "set": "btd",
    "rarity": "rare",
    "ability": "Sacrifice Hive Amber: Activate Hive.\r\nIf Hive Amber is in your general discard pile, when a Mandiblor Creature you control leaves play, you can return Hive Amber to play equipped to an Unequipped Creature you control.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/sIi0fSJ.png",
    "uniqueId": "Hive Amber__btd"
  },
  {
    "id": "137/222",
    "name": "Kha'rall Husk Armor",
    "set": "btd",
    "rarity": "rare",
    "ability": "Equipped Creature has an additional 50 Energy.\r\nWhen equipped Creature is dealt 15 or more attack damage, the next attack played by the equipped Creature this turn deals 0 damage.",
    "flavorText": "",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/h7UbQqU.png",
    "uniqueId": "Kha'rall Husk Armor__btd"
  },
  {
    "id": "138/222",
    "name": "Manual of Vidav",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "Equipped Creature has an additional 10 :wisdom:Wisdom. \r\nSacrifice Manual of Vidav: Heal 15 damage to equipped Creature. Play this ability only while equipped Creature is engaged.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/8dBpbDb.png",
    "uniqueId": "Manual of Vidav__btd"
  },
  {
    "id": "139/222",
    "name": "Maxxor's Torch",
    "set": "btd",
    "rarity": "super rare",
    "ability": "Sacrifice Maxxor's Torch: Target opponent chooses a M'arrillian or Minion Creature they control. Maxxor's Torch deals 25 damage to the chosen Creature.",
    "flavorText": "",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/Kea5BCP.png",
    "uniqueId": "Maxxor's Torch__btd"
  },
  {
    "id": "140/222",
    "name": "Mind Prism",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "Equipped Creature has an additional 10 Energy.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/YXWvz2f.png",
    "uniqueId": "Mind Prism__btd"
  },
  {
    "id": "141/222",
    "name": "Mindclasp",
    "set": "btd",
    "rarity": "rare",
    "ability": "When a source controlled by an opponent reduces any of equipped Creature's Disciplines, Mindclasp deals 5 damage to target engaged Creature.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/s9FXRTL.png",
    "uniqueId": "Mindclasp__btd"
  },
  {
    "id": "142/222",
    "name": "Mirrors of Misplacement",
    "set": "btd",
    "rarity": "super rare",
    "ability": "When a Mugic Card is put into a general discard pile, discard an Attack Card and draw an Attack Card.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/8yQ6Noi.png",
    "uniqueId": "Mirrors of Misplacement__btd"
  },
  {
    "id": "143/222",
    "name": "Parasite Tablet",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "Equipped Creature has an additional 10 :courage:Courage. \r\nSacrifice Parasite Tablet: equipped Creature gains Creature Type \"Mandiblor\" in addition to its other types. Play this ability only while equipped Creature is engaged.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/YRxmXNd.png",
    "uniqueId": "Parasite Tablet__btd"
  },
  {
    "id": "145/222",
    "name": "Phobia Tabard",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "Equipped Creature has \"Intimidate: :wisdom:Wisdom 10\" and \"Intimidate: :speed:Speed 10.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/aa4DQEd.png",
    "uniqueId": "Phobia Tabard__btd"
  },
  {
    "id": "147/222",
    "name": "Plasma Pounder",
    "set": "btd",
    "rarity": "super rare",
    "ability": "When equipped Creature deals :earth:Earth damage, you can look at the top two cards of your Location Deck. Put one of them on top and the other on the bottom.",
    "flavorText": "",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/t9jtcKw.png",
    "uniqueId": "Plasma Pounder__btd"
  },
  {
    "id": "148/222",
    "name": "Prism of Fright",
    "set": "btd",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 5 Energy. \r\nSacrifice Prism of Fright: Target Creature loses 20 :courage:Courage.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/XtygqXr.png",
    "uniqueId": "Prism of Fright__btd"
  },
  {
    "id": "149/222",
    "name": "Prism of Mindlessness",
    "set": "btd",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 5 Energy.\r\nSacrifice Prism of Mindlessness: Target Creature loses 20 :wisdom:Wisdom.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/Cej4kqf.png",
    "uniqueId": "Prism of Mindlessness__btd"
  },
  {
    "id": "150/222",
    "name": "Prism of Sloth",
    "set": "btd",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 5 Energy.\r\nSacrifice Prism of Sloth: Target Creature loses 20 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/0MK3vY0.png",
    "uniqueId": "Prism of Sloth__btd"
  },
  {
    "id": "152/222",
    "name": "Reefshard",
    "set": "btd",
    "rarity": "rare",
    "ability": "While any player controls a Chieftain Creature, equipped Creature has an additional 10 in all Disciplines.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/BREeDre.png",
    "uniqueId": "Reefshard__btd"
  },
  {
    "id": "153/222",
    "name": "Sinister Statuette",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "When equipped Creature deals 15 or more attack damage, opposing engaged Creature loses 10 in a Discipline of your choice.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/gOs8DYa.png",
    "uniqueId": "Sinister Statuette__btd"
  },
  {
    "id": "146/222",
    "name": "The Pit Token",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "Equipped Creature has an additional 10 :power:Power. \r\nSacrifice The Pit Token: Deal 10 damage to target engaged Creature. Play this ability only while equipped Creature is engaged.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/VWbvuTB.png",
    "uniqueId": "The Pit Token__btd"
  },
  {
    "id": "154/222",
    "name": "Ulmar's Bionic Steam Arms",
    "set": "btd",
    "rarity": "rare",
    "ability": "Equipped Creature deals an additional 5 damage with attacks. \r\nIf equipped Creature deals more than 20 damage with a single attack, sacrifice Ulmar's Bionic Steam Arms and deal 20 damage to the equipped Creature.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/7k5sZJ8.png",
    "uniqueId": "Ulmar's Bionic Steam Arms__btd"
  },
  {
    "id": "155/222",
    "name": "Ulmar's Projector",
    "set": "btd",
    "rarity": "rare",
    "ability": "Equipped Creature has 10 less Energy.\r\nWhen equipped Creature is destroyed while engaged, return it from the discard pile to play to any unoccupied space on your side of the Battleboard.",
    "flavorText": "",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/ZLlxP8Q.png",
    "uniqueId": "Ulmar's Projector__btd"
  },
  {
    "id": "67/100",
    "name": "Baton of Aa'une",
    "set": "roto",
    "rarity": "uncommon",
    "ability": "Equipped Creature has an additional 5 Energy. \r\nEquipped Chieftain Creature has \":water:Water 5.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/7s8yNHt.png",
    "uniqueId": "Baton of Aa'une__roto"
  },
  {
    "id": "68/100",
    "name": "Dractyl Scales",
    "set": "roto",
    "rarity": "common",
    "ability": "Sacrifice Dractyl Scales: equipped Creature gains 10 Energy and target Creature loses 10 to all Disciplines. If Dractyl Scales was equipped to H'earring, it gains an additional 10 Energy.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/jffjL91.png",
    "uniqueId": "Dractyl Scales__roto"
  },
  {
    "id": "69/100",
    "name": "Kha'rall Amber Shard",
    "set": "roto",
    "rarity": "uncommon",
    "ability": "Equipped M'arrillian or Minion Creature has :earth:Earth. \r\nEquipped Kha'rall Creature has an additional 25 Energy and \"Defender: Minion.\" \r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/rY6JiL4.png",
    "uniqueId": "Kha'rall Amber Shard__roto"
  },
  {
    "id": "70/100",
    "name": "Kha'rall Chime Shard",
    "set": "roto",
    "rarity": "uncommon",
    "ability": "Equipped M'arrillian or Minion Creature has :air:Air. \r\nEquipped Kha'rall Creature has an additional 25 Energy and \"Defender: Kha'rall.\" \r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/wYC6T8m.png",
    "uniqueId": "Kha'rall Chime Shard__roto"
  },
  {
    "id": "71/100",
    "name": "Kha'rall Freshwater Shard",
    "set": "roto",
    "rarity": "rare",
    "ability": "Equipped M'arrillian or Minion Creature has :water:Water. \r\nEquipped Kha'rall Creature has an additional 25 Energy and \"Defender: Fluidmorpher.\" \r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/xLqt2G9.png",
    "uniqueId": "Kha'rall Freshwater Shard__roto"
  },
  {
    "id": "72/100",
    "name": "Kha'rall Magma Shard",
    "set": "roto",
    "rarity": "rare",
    "ability": "Equipped M'arrillian or Minion Creature has :fire:Fire. \r\nEquipped Kha'rall Creature has an additional 25 Energy and \"Defender: Chieftain.\" \r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/tsjkfXO.png",
    "uniqueId": "Kha'rall Magma Shard__roto"
  },
  {
    "id": "73/100",
    "name": "Kha'rall Shard of the Tidal Crest",
    "set": "roto",
    "rarity": "ultra rare",
    "ability": "Equipped M'arrillian or Minion Creature has \":water:Water 5.\"\r\nAt the beginning of combat, equipped Kha'rall Creature gains 40 Energy if there are 8 or more Mugic counters among Creatures you control.\r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/CtcFiGU.png",
    "uniqueId": "Kha'rall Shard of the Tidal Crest__roto"
  },
  {
    "id": "74/100",
    "name": "Liquid Thought Evaporator",
    "set": "roto",
    "rarity": "rare",
    "ability": "Attacks played by equipped Creature also count as :water:Water attacks.\r\nWhen Liquid Thought Evaporator is flipped face-down, put a Mugic counter on the equipped Fluidmorpher Creature.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/j6oAY4c.png",
    "uniqueId": "Liquid Thought Evaporator__roto"
  },
  {
    "id": "75/100",
    "name": "Phobia Plates",
    "set": "roto",
    "rarity": "super rare",
    "ability": "Creatures engaged with equipped Creature fail all Challenges on attacks they play. \r\nEquipped Creature takes 10 less damage from Mugic.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/N7XA3Sy.png",
    "uniqueId": "Phobia Plates__roto"
  },
  {
    "id": "76/100",
    "name": "Vial of Liquid Thought",
    "set": "roto",
    "rarity": "common",
    "ability": "Sacrifice Vial of Liquid Thought: Return an Attack Card from your Attack Discard pile to your hand. If you do, place one Attack Card from your hand on the bottom of your Attack Deck.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/SdTfiLj.png",
    "uniqueId": "Vial of Liquid Thought__roto"
  },
  {
    "id": "56/100",
    "name": "Blazier's Map Collection",
    "set": "tott",
    "rarity": "rare",
    "ability": "If equipped Creature moved this turn, at the beginning of combat reveal a new active Location.",
    "flavorText": "If Blazier would only stop mapping new lands and look over his collection, he would discover that he has already found what he's been searching for his entire life.",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/si18Fgc.png",
    "uniqueId": "Blazier's Map Collection__tott"
  },
  {
    "id": "57/100",
    "name": "Bronzeflight",
    "set": "tott",
    "rarity": "rare",
    "ability": "Equipped Creature has an additional 20 :speed:Speed. \r\nIf an opposing Creature has Range, equipped Creature has \"Defender.\"\r\nThis Battlegear begins the game face-up.",
    "flavorText": "A marvel of engineering, the Bronzeflight can travel from Mipedim Oasis to Mount Pillar on a single charge.",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Keron Grant, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/cmvo5y1.png",
    "uniqueId": "Bronzeflight__tott"
  },
  {
    "id": "58/100",
    "name": "Burithean Axe",
    "set": "tott",
    "rarity": "uncommon",
    "ability": "Stat Check :power:Power 50: equipped Creature has an additional 5 Energy. \r\nStat Check :power:Power 75: equipped Creature has \"Intimidate: Energy 10.\"",
    "flavorText": "What takes 20 to wield, Rothar swings with one arm!",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/RSl2uEi.png",
    "uniqueId": "Burithean Axe__tott"
  },
  {
    "id": "59/100",
    "name": "Dread Tread",
    "set": "tott",
    "rarity": "ultra rare",
    "ability": "If equipped Creature has moved and won a combat this turn, it may move a second time, this move may begin an additonal combat",
    "flavorText": "The Dread Tread can rip through Kiru City's \"impenetrable\" walls as if they were made of paper.",
    "unique": false,
    "legendary": true,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/4c6HRqy.png",
    "uniqueId": "Dread Tread__tott"
  },
  {
    "id": "60/100",
    "name": "Evergreen Tunic",
    "set": "tott",
    "rarity": "uncommon",
    "ability": "Stat Check :courage:Courage 50: equipped Creature has an additional 5 Energy. \r\nStat Check :courage:Courage 75: equipped Creature has an additional 15 Energy.",
    "flavorText": "The perfect combination of weight, durability and flexibility.",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Robert Dizon, Stone Perales",
    "imageUrl": "https://i.imgur.com/RMEaT8u.png",
    "uniqueId": "Evergreen Tunic__tott"
  },
  {
    "id": "61/100",
    "name": "Flitflut",
    "set": "tott",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 15 :wisdom:Wisdom and 15 :speed:Speed. \r\nSacrifice Flitflut: Relocate equipped Creature to any unoccupied space on the Battleboard. Play this ability only while equipped Creature is unengaged.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Augusto Barranco",
    "imageUrl": "https://i.imgur.com/KooXMkL.png",
    "uniqueId": "Flitflut__tott"
  },
  {
    "id": "62/100",
    "name": "Girgeth Tar",
    "set": "tott",
    "rarity": "super rare",
    "ability": "Equipped OverWorld Creature has an additional 5 Energy.\r\nSacrifice Girgeth Tar: Heal 20 damage to target Creature. If the target is a Caretaker Creature, put a Mugic counter on it.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/yCPIPgn.png",
    "uniqueId": "Girgeth Tar__tott"
  },
  {
    "id": "63/100",
    "name": "Hornsabre",
    "set": "tott",
    "rarity": "ultra rare",
    "ability": "Opposing Creatures on your side of the Battleboard have \"Recklessness 5.\"",
    "flavorText": "Infused with the spirits of warriors past, the luminescent glow intensifies whenever it senses an intruder nearby.",
    "unique": false,
    "legendary": true,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/aI77kIS.png",
    "uniqueId": "Hornsabre__tott"
  },
  {
    "id": "64/100",
    "name": "Ikkatosh's Aichstick",
    "set": "tott",
    "rarity": "uncommon",
    "ability": "Stat Check :wisdom:Wisdom 50: equipped Creature has an additional 5 Energy. \r\nStat Check :wisdom:Wisdom 75: The first attack played by equipped Creature each combat has \"Untargetable.\"",
    "flavorText": "To aid in the war, Ikkatosh proved he would give part of himself... literally!",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/gRdnq5g.png",
    "uniqueId": "Ikkatosh's Aichstick__tott"
  },
  {
    "id": "65/100",
    "name": "Levitaar",
    "set": "tott",
    "rarity": "uncommon",
    "ability": "Equipped Creature has an additional 50 :speed:Speed. \r\nWhen equipped Creature is dealt attack damage, deal 5 damage to the opposing engaged Creature.",
    "flavorText": "Raznus's favorite transport before his unfortunate transformation.",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Chris Fisher, HotShotsVFX",
    "imageUrl": "https://i.imgur.com/wKq2zb4.png",
    "uniqueId": "Levitaar__tott"
  },
  {
    "id": "66/100",
    "name": "Mipedian Balladeers' Flute",
    "set": "tott",
    "rarity": "rare",
    "ability": "Sacrifice Mipedian Balladeers' Flute: Put a Mugic counter on the equipped Creature. Your opponent can put a Mugic counter on a Creature of their choice.\r\nThis Battlegear begins the game face-up.",
    "flavorText": "Melodies, harmonies, cacophonies: Mugicians love all music without prejudice.",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/JxERePB.png",
    "uniqueId": "Mipedian Balladeers' Flute__tott"
  },
  {
    "id": "67/100",
    "name": "Obliterators",
    "set": "tott",
    "rarity": "common",
    "ability": "Equipped Creature has :fire:Fire. \r\nSacrifice Obliterators: Deal 5 damage to target Creature. Play this ability only while you control Dread Tread.",
    "flavorText": "It's the perfect war machine: the Obliterators annihilate anything the Dread Tread fails to steamroll.",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/9wVDyyB.png",
    "uniqueId": "Obliterators__tott"
  },
  {
    "id": "68/100",
    "name": "Ozlai's Wreck",
    "set": "tott",
    "rarity": "common",
    "ability": "Sacrifice Ozlai's Wreck: Destroy target Battlegear equipped to an engaged Creature.",
    "flavorText": "Though Ozlai named \"The Wreck\" after what it can do to other vehicles, many believe that it's named after his state of mind.",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "Tom Baxa",
    "imageUrl": "https://i.imgur.com/E0ULmMH.png",
    "uniqueId": "Ozlai's Wreck__tott"
  },
  {
    "id": "69/100",
    "name": "Residual Lightning Dust",
    "set": "tott",
    "rarity": "uncommon",
    "ability": "Stat Check :speed:Speed 50: equipped Creature has an additional 5 Energy. \r\nStat Check :speed:Speed 75: When equipped Creature takes 20 or more damage from a single source, deal 5 damage to the opposing engaged Creature.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/Mk1ykkh.png",
    "uniqueId": "Residual Lightning Dust__tott"
  },
  {
    "id": "70/100",
    "name": "Sahrnokk",
    "set": "tott",
    "rarity": "super rare",
    "ability": "Sacrifice Sahrnokk: Creatures cannot end their move in equipped Creature's space.",
    "flavorText": "As Ørth whizzed by Gespedan to win the race and their wager, Gespedan regretted agreeing to give Ørth naming rights to his next child.",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/Re40HMj.png",
    "uniqueId": "Sahrnokk__tott"
  },
  {
    "id": "71/100",
    "name": "Scepter of the Infernal Parasite",
    "set": "tott",
    "rarity": "ultra rare",
    "ability": "If engaged with an Infected Creature, equipped Creature has \"Outperform all Disciplines 5.\"",
    "flavorText": "The parasites proved once again that determination trumps size every time.",
    "unique": false,
    "legendary": true,
    "loyal": false,
    "artist": "Augusto Barranco, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/Z4dxVRq.png",
    "uniqueId": "Scepter of the Infernal Parasite__tott"
  },
  {
    "id": "72/100",
    "name": "Van Bloot's Sickle",
    "set": "tott",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 15 :courage:Courage. \r\nAttacks played by equipped Creature have \"The opposing engaged Creature loses 10 :courage:Courage.\"",
    "flavorText": "Seeing its sharpness, even the most courageous lose heart... just before they lose their heads.",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/K9cklgD.png",
    "uniqueId": "Van Bloot's Sickle__tott"
  },
  {
    "id": "73/100",
    "name": "Warriors of Owayki",
    "set": "tott",
    "rarity": "ultra rare",
    "ability": "Mipedian Creatures you control have :genericmugic:: Deal 10 damage to target engaged Creature.\" \r\nWhen combat ends, flip Warriors of Owayki face-down.",
    "flavorText": "",
    "unique": false,
    "legendary": true,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/QYoN3Sc.png",
    "uniqueId": "Warriors of Owayki__tott"
  },
  {
    "id": "74/100",
    "name": "Weightless Energy Vessel",
    "set": "tott",
    "rarity": "rare",
    "ability": "Equipped Creature cannot be targeted by Mugic.\r\nThis Battlegear begins the game face-up.",
    "flavorText": "Even the most unimaginative Mipedians thought the name was too \"on-the-nose.\"",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/MGyBkJW.png",
    "uniqueId": "Weightless Energy Vessel__tott"
  },
  {
    "id": "75/100",
    "name": "Wing-Fin",
    "set": "tott",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 15 :courage:Courage and 15 :power:Power. \r\nSacrifice Wing-Fin: Relocate equipped Creature to any unoccupied space on the Battleboard. Play this ability only while equipped Creature is unengaged.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Augusto Barranco",
    "imageUrl": "https://i.imgur.com/hRn5CLv.png",
    "uniqueId": "Wing-Fin__tott"
  },
  {
    "id": "65/100",
    "name": "Aichlyys Wisp",
    "set": "fun",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 40 :wisdom:Wisdom and 5 Energy.",
    "flavorText": "As ephemeral as dreams and just as cherished.",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/SftlJkA.png",
    "uniqueId": "Aichlyys Wisp__fun"
  },
  {
    "id": "66/100",
    "name": "Armbands of Lore",
    "set": "fun",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 40 :courage:Courage and 5 Energy.",
    "flavorText": "\"Total control and domination!? You are fools! Control is an illusion... and that is why you will fail.\" — Lore",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Robert Dizon",
    "imageUrl": "https://i.imgur.com/hE8FfzD.png",
    "uniqueId": "Armbands of Lore__fun"
  },
  {
    "id": "67/100",
    "name": "Bodal's Dagger",
    "set": "fun",
    "rarity": "rare",
    "ability": "Equipped Creature deals an additional 10 damage with non-Elemental and non-Discipline Attacks.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/VwYQ2Ay.png",
    "uniqueId": "Bodal's Dagger__fun"
  },
  {
    "id": "68/100",
    "name": "Crown of Aa'une",
    "set": "fun",
    "rarity": "ultra rare",
    "ability": "Equipped Creature has Creature Type \"Chieftain\" in addition to its other types. (Minions use Brainwashed text. Minions can only play Generic Mugic.)",
    "flavorText": "For true leaders, the crown does not define the king. The king defines the crown.",
    "unique": false,
    "legendary": true,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/DedhX68.png",
    "uniqueId": "Crown of Aa'une__fun"
  },
  {
    "id": "69/100",
    "name": "General's Standard",
    "set": "fun",
    "rarity": "super rare",
    "ability": "When General's Standard is flipped face-up, choose a Tribe. Equipped Creature is considered to belong to that Tribe while General's Standard is face-up. (This ability does not end at the end of the turn.)",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Dave Droman",
    "imageUrl": "https://i.imgur.com/OTncy6R.png",
    "uniqueId": "General's Standard__fun"
  },
  {
    "id": "70/100",
    "name": "Gigantroper",
    "set": "fun",
    "rarity": "super rare",
    "ability": "At the beginning of combat, equipped Creature loses all abilities and gains or loses :courage:Courage, :power:Power, :wisdom:Wisdom, :speed:Speed and Energy to make those values 70.",
    "flavorText": "",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/h4bA5vf.png",
    "uniqueId": "Gigantroper__fun"
  },
  {
    "id": "71/100",
    "name": "Indigo Sash",
    "set": "fun",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 40 :speed:Speed and 5 Energy.",
    "flavorText": "\"I never expected to see an UnderWorlder wearing the emblem of our noble Mipedian ancestors. And I've never been happier.\" — Tiaane",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Robert Dizon",
    "imageUrl": "https://i.imgur.com/A5oV5wf.png",
    "uniqueId": "Indigo Sash__fun"
  },
  {
    "id": "72/100",
    "name": "Khybon's Mech-blade",
    "set": "fun",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 40 :power:Power and 5 Energy.",
    "flavorText": "The handle hides a trigger that instantly doubles the length of the blade. Naturally, Khybon has not told anyone about this feature.",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Dave Droman",
    "imageUrl": "https://i.imgur.com/seuCNbZ.png",
    "uniqueId": "Khybon's Mech-blade__fun"
  },
  {
    "id": "73/100",
    "name": "Mipedian Fulgurite",
    "set": "fun",
    "rarity": "super rare",
    "ability": "Equipped Creature has \":air:Air 10.\"\r\nWhen combat ends, destroy Mipedian Fulgurite.",
    "flavorText": "The air crackled and sizzled, as did the enemy.",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Dave Droman",
    "imageUrl": "https://i.imgur.com/3u7cfoD.png",
    "uniqueId": "Mipedian Fulgurite__fun"
  },
  {
    "id": "74/100",
    "name": "Muge's Tuningfork",
    "set": "fun",
    "rarity": "rare",
    "ability": "Equipped Creature can play Mugic from any Tribe you control.\r\nThis Battlegear begins the game face-up.",
    "flavorText": "Though Mugicians may appear to love one tribe's music over another, the fact remains they they love all music equally.",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/lpRRJi8.png",
    "uniqueId": "Muge's Tuningfork__fun"
  },
  {
    "id": "75/100",
    "name": "Riverland Moon",
    "set": "fun",
    "rarity": "common",
    "ability": "When equipped Creature deals :water:Water damage, it gains 10 to all Disciplines.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Chris Fisher",
    "imageUrl": "https://i.imgur.com/QMfZAHr.png",
    "uniqueId": "Riverland Moon__fun"
  },
  {
    "id": "76/100",
    "name": "Shard of Solitude",
    "set": "fun",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 5 Energy.\r\nIf equipped Kha'rall Creature is engaged, unengaged Creatures cannot play Mugic or activated abilities.",
    "flavorText": "\"Another one? The M'arrillians have more shards than Van Bloot has feathers!\" — Takinom",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/pjyGBJK.png",
    "uniqueId": "Shard of Solitude__fun"
  },
  {
    "id": "124/200",
    "name": "Ankh of Kehn-Sep",
    "set": "au",
    "rarity": "rare",
    "ability": "Damage dealt by equipped Creature to Creatures with no Elemental Types is increased by 5.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/vY4bHrN.png",
    "uniqueId": "Ankh of Kehn-Sep__au"
  },
  {
    "id": "125/200",
    "name": "Aquatic Familiar",
    "set": "au",
    "rarity": "common",
    "ability": "Equipped Creature has \"Expend :water:water: Gain 50 :wisdom:Wisdom.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Peter Bergting",
    "imageUrl": "https://i.imgur.com/C1grkR5.png",
    "uniqueId": "Aquatic Familiar__au"
  },
  {
    "id": "126/200",
    "name": "AZAIA Mindprobe",
    "set": "au",
    "rarity": "rare",
    "ability": "Equipped Creature cannot be targeted by Mugic or abilities played by Creatures with lower :wisdom:Wisdom than it. \r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/czxAVNw.png",
    "uniqueId": "AZAIA Mindprobe__au"
  },
  {
    "id": "127/200",
    "name": "Bi-Mowercycle",
    "set": "au",
    "rarity": "rare",
    "ability": "Equipped Creature has \"Range\" and \"Swift 1.\" \r\nSacrifice Bi-Mowercycle: Target Creature gains \"Range\" and \"Swift 1.\" \r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/o2YkxFY.png",
    "uniqueId": "Bi-Mowercycle__au"
  },
  {
    "id": "128/200",
    "name": "Citadel Fragments",
    "set": "au",
    "rarity": "common",
    "ability": "Equipped Creature has an additional 5 Energy and 5 in each Discipline for each Elemental Type it has.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/tSYu1Nf.png",
    "uniqueId": "Citadel Fragments__au"
  },
  {
    "id": "129/200",
    "name": "Citadel Lodestone",
    "set": "au",
    "rarity": "common",
    "ability": "When equipped Creature becomes engaged, it gains :earth:Earth.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/v6Qcgni.png",
    "uniqueId": "Citadel Lodestone__au"
  },
  {
    "id": "130/200",
    "name": "Colstone",
    "set": "au",
    "rarity": "super rare",
    "ability": "When any Creature engaged with the equipped Creature fails a Discipline check on an attack it played, the equipped Creature gains 10 Energy.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/Nqm7WlA.png",
    "uniqueId": "Colstone__au"
  },
  {
    "id": "131/200",
    "name": "Double Edge",
    "set": "au",
    "rarity": "common",
    "ability": "At the beginning of combat, choose \":fire:Fire 5,\" \":air:Air 5,\" \":earth:Earth 5\" or \":water:Water 5.\" equipped Creature gains the chosen ability and \"Recklessness 5.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Edwin Nebres, Anthony Washington, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/iGANGLn.png",
    "uniqueId": "Double Edge__au"
  },
  {
    "id": "132/200",
    "name": "Drilldozer, Customized Rig",
    "set": "au",
    "rarity": "rare",
    "ability": "Equipped Creature has an additional 10 Energy. If equipped Creature has :earth:Earth, it has an additional 10 Energy.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/5gisAg5.png",
    "uniqueId": "Drilldozer, Customized Rig__au"
  },
  {
    "id": "133/200",
    "name": "Flameblade of Seeryn",
    "set": "au",
    "rarity": "super rare",
    "ability": "When equipped Creature deals 30 or more :fire:Fire damage with a single attack, destroy target Battlegear.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/p4i2Hx8.png",
    "uniqueId": "Flameblade of Seeryn__au"
  },
  {
    "id": "134/200",
    "name": "Hyperhover",
    "set": "au",
    "rarity": "rare",
    "ability": "Equipped Creature has \"Untargetable\" if it has moved this turn.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/rR8HhLc.png",
    "uniqueId": "Hyperhover__au"
  },
  {
    "id": "135/200",
    "name": "Kha'rall Shard of the Staunch",
    "set": "au",
    "rarity": "rare",
    "ability": "Equipped Creature has :water:Water. \r\nEquipped Kha'rall Creature has an additional 15 Energy and \"Defender: :water:Water.\" \r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/ctvZ96K.png",
    "uniqueId": "Kha'rall Shard of the Staunch__au"
  },
  {
    "id": "136/200",
    "name": "Metabolic Overloader",
    "set": "au",
    "rarity": "common",
    "ability": "Equipped Creature has \"Expend :fire:fire: Gain 50 :power:Power.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Peter Bergting",
    "imageUrl": "https://i.imgur.com/DGs9G2v.png",
    "uniqueId": "Metabolic Overloader__au"
  },
  {
    "id": "137/200",
    "name": "Mysterious Clawblade",
    "set": "au",
    "rarity": "common",
    "ability": "Equipped Creature has \"Expend :air:Air: Gain 50 :speed:Speed.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/4W2VQTS.png",
    "uniqueId": "Mysterious Clawblade__au"
  },
  {
    "id": "138/200",
    "name": "Orb of Unda",
    "set": "au",
    "rarity": "rare",
    "ability": "Sacrifice Orb of Unda: Put a Mugic counter on equipped Creature. If equipped Creature has :water:Water, heal 10 damage from it.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/dA6DdUm.png",
    "uniqueId": "Orb of Unda__au"
  },
  {
    "id": "139/200",
    "name": "Orchis Undin",
    "set": "au",
    "rarity": "common",
    "ability": "When equipped Creature becomes engaged, it gains :water:Water.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/V8wo2o3.png",
    "uniqueId": "Orchis Undin__au"
  },
  {
    "id": "140/200",
    "name": "Phoenix Belt",
    "set": "au",
    "rarity": "rare",
    "ability": "Sacrifice Phoenix Belt: Deal 10 damage to target Creature. If equipped Creature has :fire:Fire, deal an additional 10 damage.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/zfzoWSq.png",
    "uniqueId": "Phoenix Belt__au"
  },
  {
    "id": "141/200",
    "name": "Pranker Tanker",
    "set": "au",
    "rarity": "super rare",
    "ability": "At the beginning of each turn, equipped Creature swaps spaces on the Battleboard with another unengaged Creature you control.\r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Andrew Bradshaw, Anthony Washington, David Rodriguez",
    "imageUrl": "https://i.imgur.com/gIZZ91x.png",
    "uniqueId": "Pranker Tanker__au"
  },
  {
    "id": "142/200",
    "name": "Quranium Pendant",
    "set": "au",
    "rarity": "common",
    "ability": "Equipped Creature has \"Expend :earth:earth: Gain 50 :courage:Courage.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/uOBNkB3.png",
    "uniqueId": "Quranium Pendant__au"
  },
  {
    "id": "143/200",
    "name": "Sandstorm Shroud",
    "set": "au",
    "rarity": "common",
    "ability": "When equipped Creature becomes engaged, it gains :air:Air.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/u9eiker.png",
    "uniqueId": "Sandstorm Shroud__au"
  },
  {
    "id": "144/200",
    "name": "Scarab of Khilai",
    "set": "au",
    "rarity": "super rare",
    "ability": "Equipped Creature and Creatures engaged with it cannot lose Elemental Types from Mugic, Attacks or abilities.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/DI4HlRl.png",
    "uniqueId": "Scarab of Khilai__au"
  },
  {
    "id": "S16/26",
    "name": "Skopolon",
    "set": "au",
    "rarity": "super rare",
    "ability": "At the beginning of each turn, you can look at target face-down Battlegear you do not control.\r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/scsSWAZ.png",
    "uniqueId": "Skopolon__au"
  },
  {
    "id": "145/200",
    "name": "Stormbird Statues",
    "set": "au",
    "rarity": "rare",
    "ability": "Equipped Creature has \"Swift 1.\" If equipped Creature has :air:Air, it has \"Surprise.\"\r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/Inrznoo.png",
    "uniqueId": "Stormbird Statues__au"
  },
  {
    "id": "146/200",
    "name": "Sun Chariot of Kehn-Sep",
    "set": "au",
    "rarity": "common",
    "ability": "When equipped Creature becomes engaged, it gains :fire:Fire.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/ZrJWgvE.png",
    "uniqueId": "Sun Chariot of Kehn-Sep__au"
  },
  {
    "id": "S17/26",
    "name": "Trident of Treachery",
    "set": "au",
    "rarity": "rare",
    "ability": "If equipped Creature would deal 20 or more :fire:Fire attack damage, it can deal 10 damage to a Creature of your choice instead.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/6XebUsF.png",
    "uniqueId": "Trident of Treachery__au"
  },
  {
    "id": "147/200",
    "name": "Ulmanator",
    "set": "au",
    "rarity": "rare",
    "ability": "Creatures engaged with equipped Creature have 10 less in all Disciplines for each Elemental Type they have.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/M8eHgQ1.png",
    "uniqueId": "Ulmanator__au"
  },
  {
    "id": "S18/26",
    "name": "Varanohs",
    "set": "au",
    "rarity": "rare",
    "ability": "Equipped Creature has \"Range\" and \"Swift 1\" for each Creature Card in your general discard pile.\r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/RtzNzRk.png",
    "uniqueId": "Varanohs__au"
  },
  {
    "id": "S19/26",
    "name": "Vlaric Shard, Relic of the Past",
    "set": "au",
    "rarity": "rare",
    "ability": "Equipped Creature with :earth:Earth deals an additional 5 attack damage. \r\nWhen you shuffle your Attack Deck, destroy Vlaric Shard.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/hAW6uww.png",
    "uniqueId": "Vlaric Shard, Relic of the Past__au"
  },
  {
    "id": "148/200",
    "name": "Xerium Armor",
    "set": "au",
    "rarity": "ultra rare",
    "ability": "If equipped Creature would take more than 20 damage from an attack, it takes 20 damage instead.",
    "flavorText": "",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "Khary Randolph, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/SNW93Vm.png",
    "uniqueId": "Xerium Armor__au"
  },
  {
    "id": "63/100",
    "name": "Armor of Earthen Might",
    "set": "fas",
    "rarity": "rare",
    "ability": "Damage dealt by Mugic or activated abilities to equipped Creature with :earth:Earth is reduced by 10. \r\nThis Battlegear begins the game face-up.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/I4969fD.png",
    "uniqueId": "Armor of Earthen Might__fas"
  },
  {
    "id": "OP1-14/20",
    "name": "Flux Bauble",
    "set": "op",
    "rarity": "rare",
    "ability": "At the beginning of combat, look at the top two cards of your Location Deck. Put one of them on top of that deck and the other on the bottom.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/aKVIkOT.png",
    "uniqueId": "Flux Bauble__op"
  },
  {
    "id": "OP1-15/20",
    "name": "Orb of Foresight",
    "set": "op",
    "rarity": "rare",
    "ability": "At the beginning of combat, look at the top three cards of your Attack Deck. Put one of them on top of that deck and the other two on the bottom in any order.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/dYMVHMP.png",
    "uniqueId": "Orb of Foresight__op"
  },
  {
    "id": "OP1-16/20",
    "name": "Talisman of the Mandiblor",
    "set": "op",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 15 :speed:Speed.\r\nEquipped Danian Creature has \"Sacrifice equipped Creature: Return a Mandiblor Creature Card in your general discard pile to play to any unoccupied space on the Battleboard.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/ciQOuJV.png",
    "uniqueId": "Talisman of the Mandiblor__op"
  },
  {
    "id": "P-021",
    "name": "Bodal's Element Converter",
    "set": "op",
    "rarity": "promo",
    "ability": "Equipped Creature has \":fire:Fire 5\" and \":water:Water 5.\"\r\nWhen equipped Creature deals 25 or more damage with a single attack, flip Bodal's Element Converter face-down.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/X47rwXo.png",
    "uniqueId": "Bodal's Element Converter__op"
  },
  {
    "id": "OP-qw3jcokw",
    "name": "Kha'rall Shard of Chance",
    "set": "op",
    "rarity": "super rare",
    "ability": "Equipped Creature has an additional 5 Energy and :air:Air.\r\nIf equipped Kha'rall Creature is engaged, Creatures play attacks at random.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/VMXktou.png",
    "uniqueId": "Kha'rall Shard of Chance__op"
  },
  {
    "id": "OP-0g0jkoty",
    "name": "Mommark's Energy Infuser",
    "set": "op",
    "rarity": "ultra rare",
    "ability": "At the beginning of combat, equipped Creature gains 5 Energy for each Mugic counter on it. The equipped Creature cannot gain more than 40 Energy this way.\r\nIf equipped Creature has no Mugic counters on it, destroy it.",
    "flavorText": "",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/F23ZOlY.png",
    "uniqueId": "Mommark's Energy Infuser__op"
  },
  {
    "id": "OP-9r4d1dy1",
    "name": "Olkiex' Apron",
    "set": "op",
    "rarity": "uncommon",
    "ability": "Equipped Creature has \"When equipped Creature becomes engaged, flip all Battlegear equipped to the opposing engaged Creature face-down.\"",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/pS5B3uR.png",
    "uniqueId": "Olkiex' Apron__op"
  },
  {
    "id": "P-013",
    "name": "Droskin",
    "set": "op",
    "rarity": "promo",
    "ability": "Sacrifice Droskin: Negate target attack. Play this ability only while equipped Creature is engaged.",
    "flavorText": "The Droskin is rumored to be able to absorb even the most devastating attacks.",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "Jimmy Tran, Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/vquBcPw.png",
    "uniqueId": "Droskin__op"
  },
  {
    "id": "P-011",
    "name": "The Indigo Arc",
    "set": "op",
    "rarity": "promo",
    "ability": "Equipped Creature's first attack each combat has \"Untargetable.\"",
    "flavorText": "The blade cuts with such force that neither armor nor Mugic can slow its strikes.",
    "unique": true,
    "legendary": false,
    "loyal": false,
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/2wwoh4t.png",
    "uniqueId": "The Indigo Arc__op"
  },
  {
    "id": "AU-hxdk7k6j",
    "name": "Giant Mechanical Python of Pyrithion",
    "set": "au",
    "rarity": "super rare",
    "ability": "Recklessness 10\r\nIncrease :fire:Fire attacks by 20.",
    "flavorText": "\"It's indestructible made by Ulmar.\" - Pyrithion",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "",
    "imageUrl": "https://imgur.com/MVu1yUi.png",
    "uniqueId": "Giant Mechanical Python of Pyrithion__au"
  },
  {
    "id": "AU-zivm4lns",
    "name": "Chaor's Battle Titan Statue",
    "set": "au",
    "rarity": "ultra rare",
    "ability": "Increase Energy by 50\r\nIncrease :fire:Fire attacks by 10\r\nIncrease :speed:Speed by 50\r\n\r\nOnly Chaor or Ulmar can be equipped with this Battlegear.",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "",
    "imageUrl": "https://imgur.com/jAQIbeg.png",
    "uniqueId": "Chaor's Battle Titan Statue__au"
  },
  {
    "id": "AU-8r7covq4",
    "name": "Staff of Ar'Khan From Spiritlands",
    "set": "au",
    "rarity": "super rare",
    "ability": "Returns one attack back to the opposing Creature and returns one attack by battlegear; back to the opposing Creature. Once every Battle.\r\nIf user takes 25 or more damage, destroy this.",
    "flavorText": "The Staff Belonged to the Father of Vitog. Vertog",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "",
    "imageUrl": "https://imgur.com/YMi84KC.png",
    "uniqueId": "Staff of Ar'Khan From Spiritlands__au"
  },
  {
    "id": "AU-pz1w36ou",
    "name": "Chaor's Mugic Battle Axe",
    "set": "au",
    "rarity": "super rare",
    "ability": "Increase Energy by 20\r\nIncrease :fire:Fire attacks by 5\r\nIncrease Mugic attacks by 5",
    "flavorText": "",
    "unique": false,
    "legendary": false,
    "loyal": false,
    "artist": "",
    "imageUrl": "https://imgur.com/0w0Fs2q.png",
    "uniqueId": "Chaor's Mugic Battle Axe__au"
  }
];

// Helper functions to work with the database
export const getBattlegearById = (idOrKey) => {
  // First try direct ID lookup for backward compatibility
  const directMatch = battlegearDatabase.find(battlegear => battlegear.id === idOrKey);
  if (directMatch) return directMatch;
  
  // Next try uniqueId match
  const uniqueMatch = battlegearDatabase.find(battlegear => battlegear.uniqueId === idOrKey);
  if (uniqueMatch) return uniqueMatch;
  
  // If not found, check if it's a composite key
  if (idOrKey.includes('__')) {
    const [name, set] = idOrKey.split('__');
    return battlegearDatabase.find(battlegear => 
      battlegear.name === name && battlegear.set === set
    );
  }
  
  return null;
};

export const getAllBattlegearNames = () => {
  return battlegearDatabase.map(battlegear => ({
    id: battlegear.uniqueId || createUniqueCardKey(battlegear), // Use the composite key here
    name: battlegear.name,
    set: battlegear.set || '',
    setDisplay: battlegear.set ? battlegear.set.toUpperCase() : '',
    unique: battlegear.unique || false,
    legendary: battlegear.legendary || false,
    loyal: battlegear.loyal || false,
    // Keep the original ID for reference
    originalId: battlegear.id
  }));
};
